import { useState } from 'react';
import { Content } from 'src/contexts/ContentContext';
import { InfoMessage } from 'src/core/POS/MessageWithIcon/InfoMessage';
import { vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { CrossIcon } from 'src/svgs/Viagogo';
import { IconsFill } from 'src/svgs/Viagogo/enums';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './SearchInfoBanner.css';

export const SearchInfoBanner = ({
  isOnSearchV2,
  onRedirectClick,
  standaloneRow = false,
}: {
  isOnSearchV2: boolean;
  onRedirectClick: () => void;
  standaloneRow?: boolean;
}) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  if (standaloneRow) {
    // Standalone banner
    return (
      <Stack
        direction="column"
        gap="m"
        alignItems="center"
        style={{ padding: vars.spacing.m }}
      >
        <div style={{ width: 'fit-content' }}>
          <SearchInfoBannerContent
            isOnSearchV2={isOnSearchV2}
            onRedirectClick={onRedirectClick}
            setIsVisible={setIsVisible}
          />
        </div>
      </Stack>
    );
  }

  return (
    <SearchInfoBannerContent
      isOnSearchV2={isOnSearchV2}
      onRedirectClick={onRedirectClick}
      setIsVisible={setIsVisible}
    />
  );
};

const SearchInfoBannerContent = ({
  isOnSearchV2,
  onRedirectClick,
  setIsVisible,
}: {
  isOnSearchV2: boolean;
  onRedirectClick: () => void;
  setIsVisible: (isVisible: boolean) => void;
}) => {
  const isMobile = useMatchMedia('mobile');

  return (
    <InfoMessage
      className={styles.searchMessageContainer}
      fill={IconsFill.textInverted}
      message={
        <Stack
          direction="row"
          gap="s"
          alignItems="center"
          flexWrap={isMobile ? 'wrap' : 'noWrap'}
        >
          <span
            style={{
              whiteSpace: isMobile ? 'wrap' : 'nowrap',
              fontSize: vars.typography.fontSize.base,
              fontWeight: 600,
              color: vars.color.textInvertedV2,
            }}
          >
            <Content
              id={
                isOnSearchV2
                  ? ContentId.SearchV2Introduction
                  : ContentId.SearchV2IntroductionOnV1
              }
            />
          </span>
          <Button
            variant="regular"
            onClick={onRedirectClick}
            style={{
              padding: `${vars.spacing.xxs} ${vars.spacing.m}`,
              backgroundColor: vars.color.surfacePrimary,
              color: vars.color.textBrandV2,
            }}
          >
            <div style={{ whiteSpace: 'nowrap' }}>
              <Content
                id={
                  isOnSearchV2
                    ? ContentId.SwitchBackToSearchV1
                    : ContentId.SwitchBackToSearchV2
                }
              />
            </div>
          </Button>
          <CrossIcon
            withHoverEffect
            onClick={() => {
              setIsVisible(false);
            }}
            fill={vars.color.textInvertedV2}
          />
        </Stack>
      }
    />
  );
};
